var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgKeyvaluepairs(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 39,
    height: 22.5,
    viewBox: "0 0 39 22.5",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_8",
    "data-name": "Group 8",
    transform: "translate(-4.5 -12.75)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Rectangle_1",
    "data-name": "Rectangle 1",
    transform: "translate(4.5 12.75)",
    fill: "none",
    stroke: "#707070",
    strokeWidth: 2
  }, /*#__PURE__*/React.createElement("rect", {
    width: 10,
    height: 9,
    rx: 2,
    stroke: "none"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1,
    y: 1,
    width: 8,
    height: 7,
    rx: 1,
    fill: "none"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Rectangle_5",
    "data-name": "Rectangle 5",
    transform: "translate(24.5 12.75)",
    fill: "none",
    stroke: "#707070",
    strokeWidth: 2
  }, /*#__PURE__*/React.createElement("rect", {
    width: 19,
    height: 9,
    rx: 2,
    stroke: "none"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1,
    y: 1,
    width: 17,
    height: 7,
    rx: 1,
    fill: "none"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_5",
    "data-name": "Group 5",
    transform: "translate(-0.95 -1.07)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_4",
    "data-name": "Group 4",
    transform: "translate(-4 3.5)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Rectangle_3",
    "data-name": "Rectangle 3",
    transform: "translate(23.414 11.5) rotate(45)",
    fill: "#fff",
    stroke: "#707070",
    strokeLinecap: "round",
    strokeWidth: 1
  }, /*#__PURE__*/React.createElement("rect", {
    width: 5,
    height: 2,
    rx: 1,
    stroke: "none"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 0.5,
    width: 4,
    height: 1,
    rx: 0.5,
    fill: "none"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Rectangle_9",
    "data-name": "Rectangle 9",
    transform: "translate(26.95 15.034) rotate(135)",
    fill: "#fff",
    stroke: "#707070",
    strokeLinecap: "round",
    strokeWidth: 1
  }, /*#__PURE__*/React.createElement("rect", {
    width: 5,
    height: 2,
    rx: 1,
    stroke: "none"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 0.5,
    width: 4,
    height: 1,
    rx: 0.5,
    fill: "none"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Rectangle_10",
    "data-name": "Rectangle 10",
    transform: "translate(4.5 26.25)",
    fill: "none",
    stroke: "#707070",
    strokeWidth: 2
  }, /*#__PURE__*/React.createElement("rect", {
    width: 10,
    height: 9,
    rx: 2,
    stroke: "none"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1,
    y: 1,
    width: 8,
    height: 7,
    rx: 1,
    fill: "none"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Rectangle_11",
    "data-name": "Rectangle 11",
    transform: "translate(24.5 26.25)",
    fill: "none",
    stroke: "#707070",
    strokeWidth: 2
  }, /*#__PURE__*/React.createElement("rect", {
    width: 19,
    height: 9,
    rx: 2,
    stroke: "none"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1,
    y: 1,
    width: 17,
    height: 7,
    rx: 1,
    fill: "none"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_6",
    "data-name": "Group 6",
    transform: "translate(-0.95 12)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_4-2",
    "data-name": "Group 4",
    transform: "translate(-4 3.5)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Rectangle_3-2",
    "data-name": "Rectangle 3",
    transform: "translate(23.414 11.5) rotate(45)",
    fill: "#fff",
    stroke: "#707070",
    strokeLinecap: "round",
    strokeWidth: 1
  }, /*#__PURE__*/React.createElement("rect", {
    width: 5,
    height: 2,
    rx: 1,
    stroke: "none"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 0.5,
    width: 4,
    height: 1,
    rx: 0.5,
    fill: "none"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Rectangle_9-2",
    "data-name": "Rectangle 9",
    transform: "translate(26.95 15.034) rotate(135)",
    fill: "#fff",
    stroke: "#707070",
    strokeLinecap: "round",
    strokeWidth: 1
  }, /*#__PURE__*/React.createElement("rect", {
    width: 5,
    height: 2,
    rx: 1,
    stroke: "none"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 0.5,
    width: 4,
    height: 1,
    rx: 0.5,
    fill: "none"
  })))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgKeyvaluepairs);
export default __webpack_public_path__ + "static/media/keyvaluepairs.8feeb44b79d32830d9943e4e21182eb3.svg";
export { ForwardRef as ReactComponent };